import n from "react";
import { createStore as c } from "./vanilla.es.js";
const s = (t) => t;
function a(t, e = s) {
  const r = n.useSyncExternalStore(
    t.subscribe,
    () => e(t.getState()),
    () => e(t.getInitialState())
  );
  return n.useDebugValue(r), r;
}
const u = (t) => {
  const e = c(t), r = (o) => a(e, o);
  return Object.assign(r, e), r;
}, m = (t) => u;
export {
  m as create,
  a as useStore
};
